export default {
  install(Vue, options) {
    // eslint-disable-next-line
    Vue.$auth = options.authClient;

    Object.defineProperties(Vue.prototype, {
      $auth: {
        get() {
          return options.authClient;
        },
      },
    });
  },
};
